import { z } from "zod";

import { machineWithTracksSchema } from "./machine-with-tracks";
import {
	machineCorrugateTrackSchema,
	machineCorrugateTrackWithOffsetSchema,
	machineCorrugateTrackWithToleranceSchema,
} from "./utils/machine-corrugate-track";

export const machineWithCorrugateTracksSchema = machineWithTracksSchema.extend({
	tracks: z.array(machineCorrugateTrackSchema),
});

export const machineWithCorrugateTracksWithOffsetSchema = machineWithTracksSchema.extend({
	tracks: z.array(machineCorrugateTrackWithOffsetSchema),
});

export const machineWithCorrugateTracksWithToleranceSchema = machineWithTracksSchema.extend({
	tracks: z.array(machineCorrugateTrackWithToleranceSchema),
});

export type MachineWithCorrugateTracks = z.infer<typeof machineWithCorrugateTracksSchema>;
export type MachineWithCorrugateTracksWithOffset = z.infer<typeof machineWithCorrugateTracksWithOffsetSchema>;
export type MachineWithCorrugateTracksWithTolerance = z.infer<typeof machineWithCorrugateTracksWithToleranceSchema>;
